module.exports = __webpack_public_path__ + "img/nodejs.d961ad16.png";